import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, Input, Select, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import './SearchUser.scss';
import { DDLoading } from '../../globalPageStatus';

const { confirm } = Modal;
const SIZE = 10;
class SearchUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      isMore: true, // 是否还有更多
      goodsDetails: null,
      currentSku: null,
      isPopUps: false, // 是否是弹幕数量
      selectValue: 1, // 1 我的粉丝 2 我的关注
      selectData: [],

      page: 1, // 当前页码
    };
  }

  //  查询列表
  getMyFollowFansList = (page = 1) => {
    const { base } = this.props;
    const { isMore, selectData, selectValue } = this.state;
    if (isMore) {
      this.setState({ loading: true }, () => {
        const params = {
          uid: base.uid,
          last: false,
          size: SIZE,
          page,
        };
        const httpUrl = selectValue === 1 ? '_get_my_fans' : '_get_my_follow';
        HTTP[httpUrl](params)
          .then((res) => {
            this.loading = false;
            if (res.code === 200) {
              const content = this.withContent(res.data.content);
              if (content.length < SIZE) {
                this.setState({ isMore: false });
              }
              this.setState({ selectData: [...selectData, ...content] });
            } else {
              this.setState({ isMore: false });
            }
            this.setState({ page });
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    }
  };

  // 搜索用户列表
  queryUserFriendList = (searchValue = null) => {
    const { base } = this.props;
    const { selectValue } = this.state;
    const regNum = /^\d*$/;
    if (!regNum.test(searchValue)) {
      message.warning('请正确输入用户UID进行查询');
      this.setState({ loading: false });
      return;
    }
    const params = {
      uid: base.uid,
      searchUid: searchValue,
      searchType: selectValue === 1,
    };
    HTTP._query_user_friend_list(params)
      .then((res) => {
        if (res && res.code === 200) {
          this.setState({ selectData: res.data });
        } else {
          message.warning('查询失败，请检查UID是否准确');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // 展示弹窗
  showModal = (goodsDetails, currentSku, isPopUps = false) => {
    this.setState({ visible: true, goodsDetails, currentSku, isPopUps }, () => {
      if (this.state.visible) {
        this.getMyFollowFansList();
      }
    });
  };
  // 隐藏弹窗
  hideModal = (e) => {
    e && e.preventDefault();

    this.setState({
      loading: false,
      isMore: true,
      currentSku: null,
      selectValue: 1,
      selectData: [],
      visible: false,
    });
  };

  // 搜索用户
  handleChangeSearchInput = (v) => {
    this.setState({ searchValue: v.target.value });
  };

  // 搜索
  handleSearch = () => {
    const { searchValue } = this.state;
    if (!!searchValue) {
      this.setState({ loading: true }, () => {
        this.queryUserFriendList(searchValue);
      });
    } else {
      // message.warning("请输入搜索用户UID");
      this.setState({ isMore: true, selectData: [] }, () => {
        this.getMyFollowFansList();
      });
    }
  };

  // 选择关注还是粉丝
  onChangeSelect = (val) => {
    this.setState(
      {
        selectValue: Number(val),
        selectData: [],
        isMore: true,
        searchValue: undefined,
      },
      () => {
        this.getMyFollowFansList();
      }
    );
  };

  // 赠送，走父级逻辑
  handleBuyProp = (e, item) => {
    e.preventDefault();

    const { timeUnit, handleBuyProp } = this.props;
    const { goodsDetails, currentSku, isPopUps } = this.state;

    const goodName = goodsDetails.goodsName;
    const skuPrice = currentSku.skuPrice;
    const skuNum = currentSku.num;
    const skuUnit = isPopUps
      ? `${skuNum}个`
      : timeUnit(skuNum, currentSku.unit);
    confirm({
      icon: null,
      title: '道具赠送',
      content: (
        <span>
          是否花费{skuPrice}钻石赠送
          <label>{goodName}</label>*{skuUnit}给<label>{item.remarkName}</label>?
        </span>
      ),
      className: 'daidai-confirm-style',
      centered: true,
      cancelText: '取消',
      okText: '确定',
      onOk: () => {
        this.hideModal()
        return new Promise((resolve, reject) => {
          handleBuyProp(
            currentSku,
            { ...item, ...goodsDetails, isPopUps, num: skuNum },
            () => {
              resolve();
            }
          );
        });
      },
    });
  };

  // 处理数据
  withContent = (content) => {
    if (content && content.length) {
      return content.map((item) => ({
        ...item,
        remarkName: item.nickname,
        otherUid: item.uid,
        avatar: item.headPic,
      }));
    } else {
      return [];
    }
  };

  // 滚动条监听
  handleScroll = (e) => {
    const { loading, page } = this.state;
    if (loading) return false;
    if (e.scrollHeight - (e.scrollTop + e.clientHeight) < 100) {
      this.getMyFollowFansList(page + 1);
    }
  };

  render() {
    const { loading, visible, selectValue, selectData, searchValue } =
      this.state;
    return (
      <Modal
        open={visible}
        title="赠送提示"
        width={750}
        onCancel={this.hideModal}
        footer={null}
        centered={true}
        keyboard={false}
        maskClosable={false}
        wrapClassName="daidai-modal-style has-top-border search-user-send-modal"
      >
        <DDLoading status={loading}>
          <Input.Group className="search-option-group">
            <Select
              defaultValue={selectValue}
              className="left-option"
              value={selectValue}
              onChange={this.onChangeSelect}
            >
              <Select.Option value={1}>我的粉丝</Select.Option>
              <Select.Option value={2}>我的关注</Select.Option>
            </Select>
            <Input
              value={searchValue}
              className="right-input"
              autoComplete="off"
              placeholder="请输入UID进行搜索"
              onChange={this.handleChangeSearchInput}
            />
            <button
              className="daidai-btn-primary search-submit-btn"
              onClick={this.handleSearch}
            >
              <SearchOutlined />
              <span>搜索</span>
            </button>
          </Input.Group>

          <div className="user-wrap">
            <div className="user-wrap-scroll">
              <Scrollbar
                className="nim-scroll-bar"
                ref={(el) => (this.srcollElement = el)}
                onScroll={this.handleScroll}
              >
                <ul className="user-ul">
                  {selectData && selectData.length ? (
                    selectData.map((item) => (
                      <li className="user-item" key={item.otherUid}>
                        <div className="user-avatar">
                          <div className="cover">
                            <img
                              src={Util.transImgUrl(item.avatar, '240x240')}
                              alt={item.remarkName}
                            />
                          </div>
                          <div className={`user-sex user-sex-${item.sex}`}>
                            <i className={`sex-icon icon-${item.sex}`} />
                            <span className="age">20</span>
                          </div>
                        </div>
                        <div className="user-info">
                          <p className="nick-name">{item.remarkName}</p>
                          <p className="uid">UID: {item.otherUid}</p>
                          <p className="tags">
                            <span className="tag-item">
                              {selectValue === 1 ? '粉丝' : '关注'}
                            </span>
                          </p>
                        </div>

                        <div className="operating">
                          <button
                            className="daidai-btn-primary"
                            onClick={(e) => this.handleBuyProp(e, item)}
                          >
                            赠送
                          </button>
                        </div>
                      </li>
                    ))
                  ) : (
                    <div className="not-data" />
                  )}
                </ul>
              </Scrollbar>
            </div>
          </div>
        </DDLoading>
      </Modal>
    );
  }
}

export default withRouter(SearchUser, { withRef: true });
